// Debug logger that only outputs in development
// In production, all debug statements are silently ignored

const isDevelopment = !window.location.hostname.includes('fiumed.cloud');

export function debug(...args) {
  if (isDevelopment) {
    console.log(...args);
  }
}

export function debugWarn(...args) {
  if (isDevelopment) {
    console.warn(...args);
  }
}

export function debugError(...args) {
  if (isDevelopment) {
    console.error(...args);
  }
}

// Always log errors in production too
export function error(...args) {
  console.error(...args);
}
